export default __webpack_public_path__ + "static/media/flares_token_1.d57152eb.png";